import { makeAutoObservable } from 'mobx'
import { EnumDropdownItemVariant, type IDropdownItem } from 'shared/ui'

export enum ICountriesEnum {
  US = 'US',
  CA = 'CA',
  GB = 'GB',
}

export interface ICountryData {
  flag: string
  name: string
  code: ICountriesEnum
}

type ICountrySelectStoreProps = {
  isSinchNumberVendor: boolean
}

export class CountrySelectStore {
  private _country: ICountriesEnum = ICountriesEnum.US
  private _isUKAvailable = false
  private _isSinchNumberVendor = false
  private _countries: IDropdownItem[] = [
    {
      label: 'United States',
      id: ICountriesEnum.US,
      iconL: 'flagUSA',
      variant: EnumDropdownItemVariant.CheckedRight,
    },
    {
      label: 'Canada',
      id: ICountriesEnum.CA,
      iconL: 'flagCanada',
      variant: EnumDropdownItemVariant.CheckedRight,
    },
    {
      label: 'United Kingdom',
      id: ICountriesEnum.GB,
      iconL: 'flagUK',
      variant: EnumDropdownItemVariant.CheckedRight,
    },
  ]

  constructor({ isSinchNumberVendor }: ICountrySelectStoreProps) {
    this._isSinchNumberVendor = isSinchNumberVendor

    makeAutoObservable(this)
  }

  get isUKAvailable() {
    return this._isUKAvailable && !this._isSinchNumberVendor
  }

  get countries() {
    if (this.isUKAvailable) {
      return this._countries
    }

    return this._countries.filter((country) => country.id !== ICountriesEnum.GB)
  }

  get country() {
    return this._country
  }

  get countryData() {
    const countryMap: Record<ICountriesEnum, ICountryData> = {
      [ICountriesEnum.US]: { flag: 'flagUSA', name: 'United States', code: ICountriesEnum.US },
      [ICountriesEnum.CA]: { flag: 'flagCanada', name: 'Canada', code: ICountriesEnum.CA },
      [ICountriesEnum.GB]: { flag: 'flagUK', name: 'United Kingdom', code: ICountriesEnum.GB },
    }

    return countryMap[this._country] || null
  }

  setCountry = (country: ICountriesEnum) => {
    if (!this.isCountryAvailable(country)) {
      console.warn(`Country ${country} is not available in the current configuration`)
      return
    }

    this._country = country
  }

  makeUKAvailable = () => {
    this._isUKAvailable = true
  }

  isCountryAvailable = (countryCode: ICountriesEnum): boolean => {
    return this.countries.some((country) => country.id === countryCode)
  }

  reset = () => {
    this._country = ICountriesEnum.US
    this._isUKAvailable = false
  }
}
